import React, { useEffect, useState, useContext } from 'react';
import { Table, Button, message, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { LoginContext } from '../../../../context/loginContext';

const CListaSucursalesEmpresa = () => {
  const { user } = useContext(LoginContext);
  const [sucursales, setSucursales] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchSucursales = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/sucursal/empresa`, {
        headers: { Authorization: `Bearer ${user.token}` }
      });

      if (!res.ok) throw new Error('Error al obtener sucursales');

      const data = await res.json();
      setSucursales(data);
    } catch (error) {
      console.error(error);
      message.error('Error al cargar sucursales');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSucursales();
  }, []);

  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'suc_nombre',
      key: 'suc_nombre',
    },
    {
      title: 'Dirección',
      dataIndex: 'suc_direccion',
      key: 'suc_direccion',
    },
    {
      title: 'Teléfono',
      dataIndex: 'suc_telefono',
      key: 'suc_telefono',
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (_, record) => (
        <Space>
          <Button onClick={() => navigate(`/sucursal-empresa/editar/${record.suc_id}`)}>
            Editar
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Listado de Sucursales</h2>
      <Button type="primary" onClick={() => navigate('/sucursal-empresa/nueva')} style={{ marginBottom: '1rem' }}>
        Agregar Sucursal
      </Button>

      <Table
        columns={columns}
        dataSource={sucursales}
        rowKey="suc_codigo"
        loading={loading}
      />
    </div>
  );
};

export default CListaSucursalesEmpresa;
